import {
  createStyles,
  Title,
  Text,
  Space,
  Anchor,
  Image,
  Box,
  Divider,
} from '@mantine/core';
import { themeColors } from '../../config/themeSettings';

const TraffickingRacketBust = () => {
  const { classes } = useStyles();

  return (
    <div>
      <div className={classes.dateCategory}>
        November 06, 2025 | India News
      </div>
      <section className={classes.header}>
        <Title order={1} className={classes.title}>
          Delhi Police busts trafficking racket in Paharganj spa after alert from 'Say Help' app; six women rescued
        </Title>
      </section>
      <div className={classes.container}>
        <Box className={classes.sectionCenter}>
          <Image src="https://media.newindianexpress.com/newindianexpress%2F2025-11-06%2Fyydapcx6%2Fdelhi-police-1.JPG?w=1200&auto=format%2Ccompress&fit=max" />
          <div className={classes.imageAttribution}>
            Image from New Indian Express
          </div>

          <section className={classes.paragraph}>
            <Space h="md" />
            <Text>
              <strong>NEW DELHI:</strong> Delhi Police has busted an immoral trafficking racket and rescued six women from a spa in Paharganj area after alert received through "Say Help" application, officials said on Thursday.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              About Say Help App
            </Title>
            <Space h="md" />
            <Text>
              Say Help is a global voice-activated emergency app for Android and iOS that enables users to trigger alerts via up to five custom voice phrases or a push button. It instantly sends real-time video, audio, and GPS details through SMS/WhatsApp to contacts and police, offering live monitoring and map tracking.
            </Text>
            <Space h="md" />
            <Text>
              The app includes health check-ins and a robust dashboard for responders. Say Help collaborates with NGOs and authorities to help prevent gender violence and trafficking, especially in high-risk areas like Delhi, enhancing personal and community safety, police said.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              The Alert and Investigation
            </Title>
            <Space h="md" />
            <Text>
              On the intervening night of October 30 and 31, an alert regarding suspected immoral activities was received via the Say Help App from the Paharganj area. A team of the Special Staff, Central District and the team of Say Help app was mobilized to verify and act on the information, a senior police officer said.
            </Text>
            <Space h="md" />
            <Text>
              During technical surveillance and field intelligence, reliable information was received about a spa on DBG Road, Nabi Karim, being involved in immoral trafficking and related offences.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              The Raid and Rescue
            </Title>
            <Space h="md" />
            <Text>
              A police staff as decoy customer was deputed with Rs 2,000 pre-noted currency and instructed to give a WhatsApp missed call as a signal. At around 7.30 pm, the decoy confirmed illegal activities, following which a raid was conducted where they found six women and one female receptionist involved in immoral activities, the officer said.
            </Text>
            <Space h="md" />
            <Text>
              The receptionist confessed to running the operation along with her husband. A case was registered on October 31 at Nabi Karim police station under sections 3, 4, and 5 of the Immoral Traffic Prevention Act, police said.
            </Text>
            <Space h="md" />
          </section>
          <Divider></Divider>
          <Text className={classes.footNote}>
            Story by{' '}
            <Anchor href="https://www.newindianexpress.com/author/express-news-service" target="_blank">
              Express News Service
            </Anchor>
            . Source:{' '}
            <Anchor href="https://www.newindianexpress.com/cities/delhi/2025/Nov/06/delhi-police-busts-trafficking-racket-in-paharganj-spa-after-alert-from-say-help-app-six-women-rescued" target="_blank">
              New Indian Express
            </Anchor>
          </Text>
        </Box>
      </div>
    </div>
  );
};

export default TraffickingRacketBust;

const useStyles = createStyles(theme => ({
  root: {
    fontFamily: 'Poppins',
    backgroundColor: themeColors.white,
    height: '100%',
    width: '100%',
    overflowX: 'hidden',
  },

  dateCategory: {
    fontSize: 14,
    fontWeight: 'normal',
    marginBottom: 10,
    textAlign: 'center',
    color: '#757575',
  },

  container: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
  },

  header: {
    textAlign: 'center',
    display: 'grid',
    gridTemplateColumns: 'minmax(min-content, 900px)',
    gridTemplateRows: 'auto',
    justifyContent: 'center',
    justifyItems: 'center',
    gap: 20,
  },

  footNote: {
    fontSize: 12,
    marginTop: 20,
    color: '#757575',
  },

  imageAttribution: {
    fontSize: 12,
    marginTop: 10,
    color: '#757575',
  },

  title: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: themeColors.anchor,
  },

  titleLeft: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColors.anchor,
  },

  paragraph: {
    fontFamily: 'Poppins',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColors.anchor,
  },

  sectionCenter: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '90vw',
    maxWidth: 900,
  },
}));
